import ShippingSettingsStore from './ShippingSettingsStore'

export default ShippingSettingsStore
